module.exports = __webpack_public_path__ + "static/media/male-profile.f78674e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/male-profile.png
// module id = 1273
// module chunks = 0